/**
 * 数量確認チェック (Winds Score / 2026-07-30)
 *
 * カート内に数量2以上のラインがある場合だけ、チェックアウトボタンの上に
 * 「数量をご確認ください」の確認ブロックを表示し、チェックが入るまで
 * チェックアウトへ進めないようにする(数量間違いによる誤発注の防止)。
 *
 * 仕組み(三重防御):
 *  1) 未チェックのあいだはチェックアウトボタンを disabled にする。これが主の防御。
 *     click を preventDefault する方式では止められなかった(テーマ/アプリ側のスクリプトが
 *     document の capture フェーズでボタンのクリックを拾い、form.submit() を直接呼ぶため
 *     preventDefault も stopImmediatePropagation も間に合わない。2026-07-30 に実測)。
 *     disabled ならクリックイベント自体が発生しないので、どのスクリプトも反応できない。
 *  2) 確認ブロックのチェックボックスにはテーマ標準の `cart__terms-checkbox` クラスを付けてある。
 *     theme.js の CartForm は「このクラスの要素が存在する = 同意必須」と判断し、未チェックの
 *     submit を alert で止める。よってこのスクリプトが落ちても素通りにはならない。
 *     ただしテーマ側は常に必須扱いになるため、数量が1以下のときは checked = true にして
 *     素通りさせる(= 確認が必要な状態だけ checked を外す)のがこのスクリプトの役目。
 *  3) 加えて click / submit を capture フェーズで捕まえ、赤ハイライト表示で止める(保険)。
 *
 * - 確認ブロック([data-wsqc])は Liquid 側で出力する。問屋/demo タグ(請求書払い)の顧客には
 *   ブロック自体が出力されないため、このスクリプトもテーマ側の同意必須判定も作動しない。
 * - 対象フォーム: #CartPageForm (カートページ) / #CartDrawerForm (カートドロワー)
 * - 数量は Ajax 更新で data-products が再描画されるため MutationObserver で追従する。
 */
(function () {
  'use strict';

  if (window.__wsqcLoaded) return; // main-cart / cart-drawer 両方から読まれるため二重実行を防ぐ
  window.__wsqcLoaded = true;

  var THRESHOLD = 2; // このライン数量以上で確認を要求する

  // テーマ側 alert(保険で発動したとき)の文言も数量確認向けに差し替える。
  // 規約同意チェック(settings.cart_terms_conditions_enable)は無効なので他への影響はない。
  if (window.theme && theme.strings) {
    theme.strings.cartTermsConfirmation = '数量をご確認のうえ「数量を確認しました」にチェックを入れてください。';
  }

  function qtyInputs(form) {
    return form.querySelectorAll('input[name="updates[]"]');
  }

  function maxLineQty(form) {
    var inputs = qtyInputs(form);
    var max = 0;
    for (var i = 0; i < inputs.length; i++) {
      var v = parseInt(inputs[i].value, 10);
      if (!isNaN(v) && v > max) max = v;
    }
    return max;
  }

  // 数量の組み合わせを表す文字列。数量が変わったら確認をやり直してもらう
  function qtySignature(form) {
    var inputs = qtyInputs(form);
    var parts = [];
    for (var i = 0; i < inputs.length; i++) {
      parts.push((inputs[i].getAttribute('data-id') || i) + '=' + inputs[i].value);
    }
    return parts.sort().join('|');
  }

  function syncForm(form) {
    var block = form.querySelector('[data-wsqc]');
    if (!block) return;
    var check = block.querySelector('[data-wsqc-check]');
    var wrapper = form.querySelector('.cart__checkout-wrapper');
    var inputCount = qtyInputs(form).length;
    var needed = maxLineQty(form) >= THRESHOLD;

    // 数量が変更されたら(ラインが読める状態のときだけ)確認をリセットする
    var changed = false;
    if (inputCount > 0) {
      var sig = qtySignature(form);
      changed = form.__wsqcSig !== undefined && form.__wsqcSig !== sig;
      form.__wsqcSig = sig;
    }

    if (needed) {
      if (check && (block.hidden || changed)) check.checked = false;
      if (changed) block.classList.remove('wsqc--alert');
      block.hidden = false;
    } else {
      if (!block.hidden) {
        block.hidden = true;
        block.classList.remove('wsqc--alert');
      }
      // 確認が不要なあいだはテーマ側の同意必須判定を素通りさせる
      if (check && !check.checked) check.checked = true;
    }

    var locked = needed && !(check && check.checked);
    if (wrapper) wrapper.classList.toggle('wsqc-locked', locked);

    // 主の防御: 未確認のあいだはボタン自体を無効化する
    var btn = form.querySelector('button[name="checkout"]');
    if (btn) {
      btn.disabled = locked;
      if (locked) {
        btn.setAttribute('aria-disabled', 'true');
      } else {
        btn.removeAttribute('aria-disabled');
      }
    }
  }

  function syncAll() {
    var forms = document.querySelectorAll('#CartPageForm, #CartDrawerForm');
    for (var i = 0; i < forms.length; i++) syncForm(forms[i]);
  }

  // 止めるべき状態なら確認ブロックを返す
  function blocking(form) {
    var block = form.querySelector('[data-wsqc]');
    if (!block || block.hidden) return null;
    var check = block.querySelector('[data-wsqc-check]');
    if (check && check.checked) return null;
    return block;
  }

  function warn(block) {
    block.classList.add('wsqc--alert');
    // アニメーションを毎回再生させる
    block.classList.remove('wsqc--shake');
    void block.offsetWidth;
    block.classList.add('wsqc--shake');
    try {
      block.scrollIntoView({ block: 'center', behavior: 'smooth' });
    } catch (e) {
      block.scrollIntoView();
    }
    var check = block.querySelector('[data-wsqc-check]');
    if (check) check.focus();
  }

  function guard(e) {
    var form = e.currentTarget;
    if (e.type === 'click') {
      var target = e.target;
      if (!target || !target.closest || !target.closest('[name="checkout"]')) return;
    }
    var block = blocking(form);
    if (!block) return;
    e.preventDefault();
    e.stopImmediatePropagation(); // テーマ側の alert より自前の表示を優先する
    warn(block);
  }

  function initForm(form) {
    if (form.__wsqcInit) return;
    form.__wsqcInit = true;

    // capture フェーズでテーマ本体(jQuery の bubble ハンドラ)より先に止める
    form.addEventListener('click', guard, true);
    form.addEventListener('submit', guard, true);

    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.hasAttribute && t.hasAttribute('data-wsqc-check') && t.checked) {
        var block = t.closest('[data-wsqc]');
        if (block) block.classList.remove('wsqc--alert');
      }
      syncForm(form);
    });
    form.addEventListener('input', function () { syncForm(form); });

    // 数量変更は Ajax で再描画されるので DOM の変化を監視する
    if (window.MutationObserver) {
      var timer = null;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(function () { syncForm(form); }, 60);
      }).observe(form, { childList: true, subtree: true });
    }

    syncForm(form);
  }

  function init() {
    var forms = document.querySelectorAll('#CartPageForm, #CartDrawerForm');
    for (var i = 0; i < forms.length; i++) initForm(forms[i]);
    syncAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // ドロワーが後から描画されるケースの保険
  window.addEventListener('load', init);
})();
